import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'どのくらいの期間で成果が出ますか？',
      answer: '早いケースでは1〜2ヶ月で変化が出始めます。初期は以下を集中的に行います。・現状整理・課題の言語化・KPI設計・業務整理・実行優先度の明確化その後、3ヶ月前後で「数字・業務の回り方」に明確な変化が出るケースが多いです。※成果のスピードは、業種・フェーズ・稼働量により異なります。'
    },
    {
      question: '支援開始までどれくらいの期間がかかりますか?',
      answer: '最短で初回ヒアリングから1週間以内に支援を開始できます。状況に応じて柔軟に対応いたしますので、お急ぎの場合はご相談ください。'
    },
    {
      question: 'どのような経営フェーズの会社が対象ですか？',
      answer: '一人経営〜少人数（〜20名程度）を主な対象としています。特に、・経営者が営業・採用・現場を兼務している・人を増やす前に業務を整えたい・右腕となる実行担当が欲しいといったフェーズの企業様と相性が良いです。'
    },
    {
      question: 'オンラインでの支援は可能ですか?',
      answer: 'はい、全国どこからでもオンラインで支援可能です。Zoom、Google Meet、Microsoft Teamsなど、貴社の環境に合わせて対応いたします。必要に応じて訪問も可能です。'
    },
    {
      question: '営業代行では具体的にどこまで対応してもらえますか?',
      answer: '新規顧客開拓、商談同行、提案書作成、案件管理、顧客折衝まで一貫して対応します。SES/受託開発の営業であれば、エンジニアのアサイン調整やプロジェクト進捗管理も可能です。'
    },
    {
      question: '採用支援では具体的に何をしてもらえますか?',
      answer: '採用戦略策定、求人票作成、スクリーニング、面談代行、オファー面談、入社後フォローまで対応します。特にエンジニア採用では、技術面談やキャリア支援も行います。'
    },
    {
      question: '最低契約期間はありますか?',
      answer: '月数時間〜週数日まで、柔軟に調整可能です。課題や優先度に応じて、・定例ミーティング・実務対応・チャット相談などを組み合わせてご支援します。'
    },
    {
      question: '料金体系はどうなっていますか?',
      answer: '基本は月額制です。業務内容・稼働量に応じてご提案します。業務設計・実行・改善まで継続的に関わるため、スポット契約ではなく月額でのご支援を基本としています。'
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq">
      <div className="container">
        <div className="faq__header animate-on-scroll">
          <h2 className="faq__title">
            よくあるご質問
          </h2>
          <p className="faq__subtitle">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="faq__list">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`faq__item animate-on-scroll ${activeIndex === index ? 'faq__item--active' : ''}`}
              style={{ animationDelay: `${0.05 + index * 0.05}s` }}
            >
              <button 
                className="faq__question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <span className="faq__question-text">Q. {faq.question}</span>
                <span className="faq__question-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
              
              <div className="faq__answer">
                <div className="faq__answer-content">
                  <p>A. {faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq__contact animate-on-scroll" style={{ animationDelay: '0.5s' }}>
          <p className="faq__contact-text">
            その他のご質問がございましたら<br className="mobile-break" />
            お気軽にお問い合わせください
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;